import request from "@/utils/request";


export function getEmtiazDetails(formSerial) {
  return request({
    url: "shafahi/emtiazdetails",
    method: "post",
    data: { FormSerial: formSerial },
  });
}

export function getShafahiHistory() {
  return request({
    url: 'shafahi/gethistory',
    method: 'post'
  })
}

export function downloadAttach(requestID, token) {
  return request({
    url: "/shafahi/downloadattach",
    method: "post",

    data: { RequestID: requestID, HashToken: token },
  });
}
